export const mutations = {
  STORE_TRUCKTRACKINGS(state, trucktrackings) {
    state.trucktrackings = trucktrackings;
  },
  STORE_TRUCKTRACKING_UPDATE(state, trucktrackingId) {
    let Trucktracking = state.trucktrackings.find(function(trucktracking) {
      return trucktracking.id === trucktrackingId;
    });
    state.systemTrucktracking = Trucktracking;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/trucktrackings/mutations.js